/* unplugin-vue-components disabled */import { render } from "./Frame.vue?vue&type=template&id=7cdb35f7"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"

import "./Frame.vue?vue&type=style&index=0&id=7cdb35f7&lang=css"

import exportComponent from "D:\\workspace\\orc_wt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__